(() => {
  function init(root = document) {
    root.querySelectorAll('.jc-form').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const config = JSON.parse(form.querySelector('[data-commission-config]').textContent);
      const month = form.querySelector('[data-month]');
      const format = new Intl.DateTimeFormat(config.locale, {month:'long',year:'numeric',timeZone:'UTC'});
      const label = (value, offset = 0) => { const [y,m] = value.split('-').map(Number); return format.format(new Date(Date.UTC(y,m-1+offset,1))); };
      const applySchedule = (id, value) => {
        month.value = id;
        month.dataset.monthValue = value;
        form.querySelector('[data-production-label]').textContent = label(value);
        form.querySelector('[data-shipping-label]').textContent = label(value,2);
        const schedule = config.schedule.replace('{production}',label(value)).replace('{shipping}',label(value,2));
        form.querySelector('[data-summary]').textContent = schedule;
        form.querySelector('[data-shipping-value]').value = label(value,2);
        form.querySelector('[name="properties[Délai accepté]"]').checked = false;
      };
      const renderQueue = variants => {
        const parts = new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Paris',year:'numeric',month:'2-digit'}).formatToParts(new Date());
        const current = parts.find(p=>p.type==='year').value+'-'+parts.find(p=>p.type==='month').value;
        const queue = form.querySelector('[data-queue]'); queue.replaceChildren();
        variants.filter(v=>/^\d{4}-\d{2}$/.test(v.title)&&v.title>=current&&v.title<month.dataset.monthValue&&!v.available).sort((a,b)=>a.title.localeCompare(b.title)).forEach(v=>{
          const badge=document.createElement('span');
          badge.textContent=label(v.title)+' · '+config.queueFull;
          queue.append(badge);
        });
        queue.hidden = !queue.childElementCount;
      };
      applySchedule(month.value, month.dataset.monthValue);
      renderQueue(config.variants);
      const earliest = variants => {
        const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Paris',year:'numeric',month:'2-digit'}).formatToParts(new Date());
        const current = parts.find(p => p.type === 'year').value + '-' + parts.find(p => p.type === 'month').value;
        return variants.filter(v => v.available && /^\d{4}-\d{2}$/.test(v.title) && v.title >= current).sort((a,b) => a.title.localeCompare(b.title))[0];
      };
      // Handle validation here so hidden file inputs and distant fields get useful feedback.
      form.noValidate = true;
      const english = config.locale.startsWith('en');
      const text = (fr, en) => english ? en : fr;
      const fieldErrors = new Map();
      const messageFor = field => {
        if (field.validity.customError) return field.validationMessage;
        if (field.type === 'file') return text('Ajoutez une photo pour que je puisse peindre votre sujet.', 'Add a photo so I can paint your subject.');
        if (field.name === 'properties[Délai accepté]') return text('Confirmez le délai de création et d’envoi pour continuer.', 'Please accept the production and dispatch timeline to continue.');
        if (field.name === 'properties[Sujet accepté]') return text('Confirmez que votre photo montre un animal ou un objet.', 'Please confirm that your photo shows an animal or an object.');
        if (field.type === 'email') return text('Indiquez une adresse e-mail valide pour que je puisse vous écrire.', 'Enter a valid email address so I can get in touch.');
        if (field.tagName === 'TEXTAREA') return text('Racontez-moi en quelques mots ce que ce sujet représente pour vous.', 'Tell me in a few words what this subject means to you.');
        return text('Complétez ce champ pour continuer.', 'Complete this field to continue.');
      };
      const clearFieldError = field => {
        const entry = fieldErrors.get(field);
        if (!entry) return;
        entry.node.remove();
        field.removeAttribute('aria-invalid');
        if (entry.describedby === null) field.removeAttribute('aria-describedby');
        else field.setAttribute('aria-describedby', entry.describedby);
        entry.target.style.outline = entry.outline;
        entry.target.style.outlineOffset = entry.offset;
        fieldErrors.delete(field);
      };
      const showFieldError = field => {
        if (fieldErrors.has(field)) { fieldErrors.get(field).node.textContent = messageFor(field); return; }
        const target = field.type === 'file' ? form.querySelector('.jc-upload-label') : field;
        const node = document.createElement('p');
        node.id = form.id + '-validation-' + [...form.elements].indexOf(field);
        node.textContent = messageFor(field);
        node.style.cssText = 'color:#a12d27;font-weight:600;font-size:15px;line-height:1.5;margin:8px 0 16px';
        const describedby = field.getAttribute('aria-describedby');
        field.setAttribute('aria-describedby', [describedby, node.id].filter(Boolean).join(' '));
        field.setAttribute('aria-invalid', 'true');
        fieldErrors.set(field, {node, target, describedby, outline:target.style.outline, offset:target.style.outlineOffset});
        target.style.outline = '2px solid #a12d27'; target.style.outlineOffset = '3px';
        (field.closest('label') || field).insertAdjacentElement('afterend', node);
      };
      const validateFields = () => {
        const invalid = [...form.elements].filter(field => field.willValidate && !field.validity.valid);
        [...fieldErrors.keys()].forEach(field => { if (field.validity.valid) clearFieldError(field); });
        const summary = form.querySelector('[data-error]');
        if (!invalid.length) { summary.hidden = true; return true; }
        invalid.forEach(showFieldError);
        summary.textContent = text('Il reste quelques informations à compléter. Les champs concernés sont indiqués en rouge.', 'A few details are still missing. Please complete the fields highlighted in red.');
        summary.hidden = false;
        const first = fieldErrors.get(invalid[0]);
        if (invalid[0].type === 'file') first.target.tabIndex = -1;
        first.target.focus({preventScroll:true});
        const header = document.getElementById('header-group');
        const top = window.scrollY + first.target.getBoundingClientRect().top - (header?.getBoundingClientRect().height || 80) - 28;
        window.scrollTo({top:Math.max(0,top),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        return false;
      };
      const clearResolved = event => {
        if (event.target.validity?.valid) clearFieldError(event.target);
        if (!fieldErrors.size) form.querySelector('[data-error]').hidden = true;
      };
      form.addEventListener('input', clearResolved);
      form.addEventListener('change', clearResolved);
      const photo = form.querySelector('[data-photo]'); let previewUrl;
      photo.addEventListener('change', () => {
        const file = photo.files[0];
        const valid = !file || (['image/jpeg','image/png','image/webp'].includes(file.type) && file.size <= 10*1024*1024 && file.size > 0);
        photo.setCustomValidity(valid ? '' : config.photoError);
        const preview = form.querySelector('[data-photo-preview]');
        if(previewUrl) URL.revokeObjectURL(previewUrl);
        preview.hidden = !file || !valid;
        if (file && valid) { previewUrl = URL.createObjectURL(file); preview.src = previewUrl; }
        const status = form.querySelector('[data-photo-status]');
        status.hidden = !file || !valid;
        status.textContent = file && valid ? config.photoReady : '';
        photo.closest('fieldset').classList.toggle('has-photo', Boolean(file && valid));
        if (!valid) showFieldError(photo); else clearFieldError(photo);
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (form.dataset.sending || !validateFields()) return;
        const button = form.querySelector('button[type=submit]');
        const error = form.querySelector('[data-error]'); const original = button.innerHTML;
        error.hidden = true; button.disabled = true; button.textContent = config.sending; form.dataset.sending = 'true';
        try {
          const availability = await fetch(config.productUrl, {cache:'no-store',headers:{Accept:'application/json'}});
          if (!availability.ok) throw new Error(config.error);
          const liveVariants = (await availability.json()).variants;
          const next = earliest(liveVariants);
          if (!next) { const failure = new Error(config.unavailable); failure.shopify = true; throw failure; }
          if (String(next.id) !== month.value) {
            applySchedule(String(next.id), next.title);
            renderQueue(liveVariants);
            form.querySelector('[data-total-price]').textContent = new Intl.NumberFormat(config.locale, {style:'currency',currency:window.Shopify?.currency?.active || 'EUR'}).format(next.price / 100);
            form.querySelector('[name="properties[Délai accepté]"]').focus();
            const failure = new Error(config.changed); failure.shopify = true; throw failure;
          }
          const response = await fetch(config.addUrl, {method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
          const result = await response.json();
          if (!response.ok) { const failure = new Error(typeof result.description === 'string' ? result.description : config.error); failure.shopify = true; throw failure; }
          window.location.assign((window.Shopify?.routes?.root||'/')+'checkout');
        } catch (e) {
          error.textContent = e.shopify ? e.message : config.error;
          error.hidden = false; button.disabled = false; button.innerHTML = original; delete form.dataset.sending;
        }
      });
    });
  }
  init(); document.addEventListener('shopify:section:load',event => init(event.target));
})();
